<template>
  <div class="container p-4" >
    <card >
      <div class="row">
        

        <div class="row">
  <div class="col-md-12" style="left: 6% !important;" >
    <h4 slot="header" class="card-title" >{{ window_title }}</h4>
    <div class="circle-image">
      <img v-if="form_update.url_image != null && form_update.url_image != ''" :src="form_update.url_image" alt="..." class="img-fluid ms-3" style="height: 200px; width: 200px; margin: none; object-position: center; object-fit: cover; border-radius: 10%;" />
      <img v-else
        src="../../../public/img/logochami.png"
        alt="default_profile"
        class="img-fluid ms-3"
        style="height: 120px; width: 180px; margin: none; object-position: center; border-radius: 10%;"
      />
    </div>
  </div>
  <!-- <div class="col-md-7 mt-3" style="left: 3% !important;">
    <label>Cambiar imagen de perfil</label>
    <br />
    <div style="position: relative">
      <file-pond
        ref="filePond"
        accepted-file-types="image/jpeg, image/png"
        name="image"
        v-model="form_update.url_image"
        label-idle="Subir imagen"
        @updatefiles="handleFileUpdate"
        @removefile="handleFileUpdate"
      ></file-pond>
       <img
        id="backgroundImage"
        src="../../../public/img/load_img.jpg"
        style="
          position: absolute;
          top: 0;
          left: 0;
          pointer-events: none;
          opacity: 0.5;
          height: 148px;
          width: 100%;
        "
      />
    </div>
  </div> -->
</div>
</div>

      <form role="form">
        <div class="row">
          <div class="col-md-6">
            <div class="col-md-12">
            
  <label for="first_name">Nombres</label>
  <br>
  <input
    id="first_name"
    class="my-input-style"
    type="text"
    placeholder="Indica tus nombres"
    v-model="form_update.first_name"
  >

            </div>
            <div class="col-md-12">
              <label for="last_name">Apellidos</label>
  <br>
  <input
    id="last_name"
    class="my-input-style"
    type="text"
    placeholder="Indica tus apellidos"
    v-model="form_update.last_name"
  >
              <br>
              <br>
            </div>
            <!-- <div class="col-md-12">
              <label for="dni">Cédula de identidad / Pasaporte</label>
  <br>
  <input
    id="dni"
    class="my-input-style"
    type="text"
    placeholder="Indica tu cédula o pasaporte"
    v-model="form_update.dni"
  >
             
            </div> -->
            <!-- <div class="col-md-12">
              <label for="phone">Teléfono</label>
  <br>
  <input
    id="phone"
    class="my-input-style"
    type="number"
    placeholder="Indica tu teléfono"
    v-model="form_update.phone"
  >
              
            </div> -->
            <!-- <div class="col-md-12">
                            <label>Genero</label>
                            <multiselect
                              v-model="form_update.gender"
                              label="name"
                              :options="genderTmp"
                              selectLabel="Click/enter para elegir"
                              selectedLabel="Seleccionado"
                              deselectLabel="Click/Enter para remover"
                              select-label="Seleccionar"
                              placeholder="Seleccione"
                              style="
                                border-radius: 30px !important;
                                text-transform: none;
                                color: black;
                              "
                            >
                            </multiselect>
                          </div> -->
            
          </div>

          <div class="col-md-6">
            <div class="col-md-12" style="top: -15px;">
              
  <label>Fecha de nacimiento</label>
  
  <date-picker 
    class="form-control align-content-center d-flex my-input-style"
    style="width:100%; height: 50%; flex-wrap: wrap;" 
    v-model="form_update.birthdate" 
    :format="'DD/MM/YYYY'"
    :disabled-date="disableFutureDates"
    placeholder="Selecciona una fecha">
  </date-picker>
</div>
            <div class="col-md-12" style="top: -15px;">
              <label for="email">Correo</label>
  <br>
  <input
    id="email"
    class="my-input-style"
    type="email"
    placeholder="Indica tu correo"
    v-model="form_update.email"
  >
            </div>

            <!-- <div class="col-md-12">
              <label>País</label>
              <multiselect
                v-model="form_update.country"
                label="name"
                :options="sortedCountryTmp"
                selectLabel="Click/enter para elegir"
                selectedLabel="Seleccionado"
                deselectLabel="Click/Enter para remover"
                select-label="Seleccionar"
                placeholder="Seleccione"
                @input="loadState()"
                style="
                  border-radius: 30px !important;
                  text-transform: capitalize;
                  color: white;
                "
              >
              </multiselect>
            </div> -->

            <!-- <div class="col-md-12">
              <label>Estado</label>
              <multiselect
                v-model="form_update.state"
                label="name"
                :options="StateTmp"
                selectLabel="Click/enter para elegir"
                selectedLabel="Seleccionado"
                deselectLabel="Click/Enter para remover"
                select-label="Seleccionar"
                placeholder="Seleccione"
                style="
                  border-radius: 30px !important;
                  text-transform: capitalize;
                  color: white;
                "
                :disabled="!form_update.country"
              >
              </multiselect>
              <p
                v-if="!form_update.country"
                style="
                  color: rgb(184, 49, 49);
                  text-transform: none !important;
                  font-size: 11px;
                "
              >
                Debe seleccionar un Pais para seleccionar un Estado
              </p>
            </div> -->

            <!-- <div class="col-md-12">
              <label>Actualizar contraseña</label>
              <input
                type="checkbox"
                class="ms-2 "
                v-model="showPasswordFields"
              />
            </div> -->

            <div v-if="showPasswordFields" class="col-md-12">
              <label for="password">Contraseña</label>
  <br>
  <input
    id="password"
    class="my-input-style"
    type="password"
    placeholder="Indica tu Contraseña"
    v-model="form_update.password"
  >
              
            </div>
            <div v-if="showPasswordFields" class="col-md-12">
              <label for="password">Repite tu Contraseña</label>
  <br>
  <input
  v-if="form_update.password"
    id="password"
    class="my-input-style"
    type="password"
    placeholder="Confirma tu contraseña"
    v-model="form_update.password2"
  >
             
              <input
                v-else
                type="password"
                label="Repite la contraseña"
                class="my-input-style"
                placeholder="Confirma tu contraseña"
                v-model="checkEmptyPassword"
                disabled
              >
              </input>
            </div>
            <div class="col-md-12 mt-4">
              <div class="text-center">
                <!-- <button
                  type="button"
                  class="btn bg-gradient-fvf"
                  @click="updateElement"
                  style="border-radius: 5px !important; background: #651366 !important; color: white !important;"
                >
                  <span>Actualizar</span>
                </button> -->
              </div>
            </div>
          </div>
        </div>
      </form>
    </card>
  </div>
</template>
<script>
import Card from "src/components/Cards/Card.vue";
import { mapState } from "vuex";
import { mapActions } from "vuex";
import Swal from "sweetalert2";
import Multiselect from "vue-multiselect";
import DatePicker from "vue2-datepicker";
import es from "vue2-datepicker/locale/es";
import LTable from "src/components/Table.vue";
import moment from "moment";
// import LoadImage from "../../../public/img/load_img.jpg";
// import ObservationChat from "src/components/ObservationChat.vue";
import Cookies from "js-cookie";
import vueFilePond from "vue-filepond";
import "filepond/dist/filepond.min.css";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
const FilePond = vueFilePond(
  FilePondPluginFileValidateType,
  FilePondPluginImagePreview
);

export default {
  components: {
    Card,
    Multiselect,
    FilePond,
    DatePicker,
    LTable,
    // ObservationChat,
  },
  data() {
    return {
      window_title: "Mi perfil",
      button_label: "Actualizar información",
      locale: { lang: "es", weekDays: ["L", "M", "M", "J", "V", "S", "D"] },
      countries: [],
      loaded: false,
      showPasswordFields: false,

      id_user_logged: Cookies.get("id"),
      genderTmp: [
        {
          id: 1,
          name: 'Femenino'
        },
        {
          id: 2,
          name: 'Masculino'
        },
        {
          id: 0,
          name: 'No definido'
        }
      ],

      form_update: {
        id: 0,
        url_image: "",
        first_name: "",
        last_name: "",
        dni: "",
        phone: "",
        email: "",
        gender:"",
        birthdate:"",
        bio:"",
        country: {
          id: "",
          name: "",
        },
        state: {
          id: "",
          name: "",
        },
      },

      CountryTmp: [],
      StateTmp: [],
    };
  },
  mounted() {
    this.getElement(this.id_user_logged);
    // this.loadCountry();
    // this.loadState();
    DatePicker.locale("es", es);
  },
  computed: {
    ...mapState({
      me: (state) => state.auth.me,
      me_rol: (state) => state.auth.me_rol,
    }),
    sortOptions() {
      return [];
    },
    sortedStateTmp() {
      return this.StateTmp.slice().sort((a, b) => a.name.localeCompare(b.name));
    },
    sortedCountryTmp() {
      return this.CountryTmp.sort((a, b) => a.name.localeCompare(b.name));
    },

    checkEmptyPassword() {
      console.log('hola');
      if (this.form_update.password == "") {
        return (this.form_update.password2 = "");
      }
    },
  },
  methods: {
    ...mapActions(["getData", "updateData", "changeStatusData", "createData",'updateDataAutenticated']),
    // showObs() {
    //   $("#modalObs").modal("toggle");
    //   this.$refs.ObservationChat.loadObservations();
    // },

    changeDate() {
      console.log(this.form_update.date_registration_rif);
    },

    prefixChange() {
      console.log(this.form_update.prefix);
      this.prefixTemp = [
        {
          id: 0,
          name: "V-",
        },
        {
          id: 1,
          name: "J-",
        },
        {
          id: 2,
          name: "G-",
        },
        {
          id: 3,
          name: "E-",
        },
      ];
    },
    disableFutureDates(date) {
      return date > new Date();
    },
    getElement(id) {
      this.loaded = false;
      let data_params = {
        url: "user/" + id,
        params: {
          active: 1,
          order_by: "id",
          order_key: "desc",
        },
      };

      this.getData(data_params)

        .then((response) => {
          this.form_update = response.data;

          this.form_update.gender = this.genderTmp.find(
            (x) => x.id === this.form_update.gender
          );

          if (!this.form_update.birthdate) {
            const date = new Date();
            const formattedDate = `${date.getFullYear()}-${(
              "0" +
              (date.getMonth() + 1)
            ).slice(-2)}-${("0" + date.getDate()).slice(-2)} ${(
              "0" + date.getHours()
            ).slice(-2)}:${("0" + date.getMinutes()).slice(-2)}:${(
              "0" + date.getSeconds()
            ).slice(-2)}`;
            this.form_update.birthdate = formattedDate;
          } else {
            this.form_update.birthdate = new Date(this.form_update.birthdate);
            this.form_update.birthdate.setHours(
              this.form_update.birthdate.getHours() +
                this.form_update.birthdate.getTimezoneOffset() / 60
            );
            console.log(this.form_update.birthdate);
          }
          // this.loadCountry();
          // this.loadState();

          this.loaded = true;
        })
        .catch((error) => {
          this.loaded = true;
          console.log(error);
        });
    },
    returnUrl() {
      this.$router.go(-1);
    },

    changeStatus(data) {
      let active = data.active === 1 ? 2 : 1;
      let title = data.active === 1 ? "Eliminar" : "Activar";
      let title2 = data.active === 1 ? "Desactivado" : "Activado";
      let text =
        data.active === 1
          ? "¿Estás seguro de eliminar este usuario?"
          : "¿Estás seguro de activar este usuario?";
      Swal.fire({
        title: title,
        text: text,
        icon: "question",
        reverseButtons: true,
        showCancelButton: true,
        confirmButtonColor: "#430098ff",
        cancelButtonColor: "#c4c5c8ff",
        confirmButtonText: "Eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.value) {
          let form = {
            id: data.id,
            url: "user_club/change_status",
            status: active,
          };
          this.changeStatusData(form)
            .then((response) => {
              if (response.code === 200) {
                this.loadUserClubs();
                data.active = active;
                Swal.fire({
                  title: "Usuario eliminado correctamente",
                  icon: "success",
                  showConfirmButton: false,
                  showLoaderOnConfirm: true,
                  confirmButtonColor: "#430098ff",
                  timer: 1000,
                });
              }
            })
            .catch((error) => {
              console.log(error);
            });
        }
      });
    },

    handleFileUpdate(files) {
      if (
        files.length > 0 &&
        files[0].file !== undefined &&
        files[0].file !== null &&
        files[0].file !== ""
      ) {
        const file = files[0];
        const reader = new FileReader();

        reader.onload = (e) => {
          const backgroundImage = document.getElementById("backgroundImage");
          backgroundImage.src = "";
        };

        reader.readAsDataURL(file.file);
      } else {
        console.log("No hay archivo");
        const backgroundImage = document.getElementById("backgroundImage");
        backgroundImage.src = LoadImage;
      }
    },

    updateElement() {
      if (this.form_update.password && this.form_update.password.length < 8) {
        Swal.fire({
          title: "Contraseña inválida",
          text: "La contraseña debe tener al menos 8 caracteres",
          icon: "warning",
          showConfirmButton: true,
          showLoaderOnConfirm: true,
        });
      } else if (this.form_update.password !== this.form_update.password2) {
        Swal.fire({
          title: "¡Atención!",
          text: "Las contraseñas no coinciden",
          icon: "warning",
          showConfirmButton: false,
          showLoaderOnConfirm: true,
          timer: 1000,
        });
        return;
      } else if (!this.form_update.first_name) {
        Swal.fire({
          title: "¡Atención!",
          text: "Debe ingresar un nombre",
          icon: "warning",
          showConfirmButton: false,
          showLoaderOnConfirm: true,
          timer: 1000,
        });
        return;
      } else if (!this.form_update.last_name) {
        Swal.fire({
          title: "¡Atención!",
          text: "Debe ingresar un apellido",
          icon: "warning",
          showConfirmButton: false,
          showLoaderOnConfirm: true,
          timer: 1000,
        });
        return;
      }  else if (!this.form_update.email) {
        Swal.fire({
          title: "¡Atención!",
          text: "Debe ingresar un correo electrónico",
          icon: "warning",
          showConfirmButton: false,
          showLoaderOnConfirm: true,
          timer: 1000,
        });
        return;
      } else {
        Swal.fire({
          title: "¡Atención!",
          text: "¿Estás seguro de actualizar su información?",
          icon: "question",
          reverseButtons: true,
          showCancelButton: true,
          confirmButtonColor: "#F76E2A",
          cancelButtonColor: "#651366",
          cancelButtonText: "Cancelar",
          confirmButtonText: "Si, actualizar",
        }).then((result) => {
          let data_form;

          if (result.value) {
            data_form = new FormData();
            data_form.append("first_name", this.form_update.first_name);
            data_form.append("last_name", this.form_update.last_name);
            data_form.append("email", this.form_update.email);
            data_form.append("phone", this.form_update.phone);
            // data_form.append("gender", this.form_update.gender ? this.form_update.gender.id : 0);
            // data_form.append("id_country", this.form_update.country.id);
            // data_form.append("id_state", this.form_update.state.id);
            // data_form.append("dni", this.form_update.dni);
            data_form.append("birthdate", new Date(this.form_update.birthdate)
                .toISOString()
                .slice(0, 10));
            if (
              this.form_update.password !== "" &&
              this.form_update.password !== null &&
              this.form_update.password !== undefined
            ) {
              data_form.append("password", this.form_update.password);
            }
            
            console.log("hola", this.$refs.filePond.getFiles());
            const filePondInstance = this.$refs.filePond.getFiles();
            if (
              filePondInstance &&
              filePondInstance.length > 0 &&
              filePondInstance[0].file
            ) {
              data_form.append("url_image", filePondInstance[0].file);
            }
          }

          this.deleting = true;
          let form = {
            url: "user/update",
            id: this.id_user_logged,
            data: data_form,
          };
          this.updateData(form)
            .then((response) => {
              if (response.code === 200) {
                this.deleting = false;
                Swal.fire({
                  title: "Datos actualizados correctamente",
                  icon: "success",
                  showConfirmButton: false,
                  showLoaderOnConfirm: true,
                  timer: 1000,
                });

                // const expires_in = moment().format("YYYY-MM-DD HH:mm");
                // const expires_at = moment(expires_in).add(4, 'hours').format("YYYY-MM-DD HH:mm");
                // const expires_at_date = new Date(expires_at);
                // Cookies.remove("id_type_user");
                // Cookies.set("id_type_user", id_type_user, { expires: expires_at_date });

                location.reload(true);
                // this.getElement(this.id_user_logged);
              }
              if (response.code === 403) {
                this.deleting = false;
                Swal.fire({
                  title: "Ya existe otro usuario con este teléfono",
                  icon: "warning",
                  showConfirmButton: true,
                  showLoaderOnConfirm: true,
                });
                // this.$router.push("registro");
              }
              if (response.code === 409) {
                this.deleting = false;
                Swal.fire({
                  title: "Ya existe un usuario con estos datos",
                  icon: "warning",
                  showConfirmButton: true,
                  showLoaderOnConfirm: true,
                });
                // this.$router.push("registro");
              }
              if (response.code === 410) {
                  this.deleting = false;
                  Swal.fire({
                    title: "Ya existe un usuario con este RNE",
                    icon: "warning",
                    sshowConfirmButton: true,
                    showLoaderOnConfirm: true,
                  });
                }
            })
            .catch((error) => {
              console.log(error);
              this.deleting = false;
              alert("Ocurrió un error, intente más tarde");
            });
        });
      }
    },

    loadState() {
      let form = {
        url: "master/state/all",
        params: {
          id_country: this.form_update.country
            ? this.form_update.country.id
            : null,
          order_key: "asc",
          order_by: "name",
          active: 1,
        },
      };

      this.isBusy = true;
      this.getData(form)
        .then((response) => {
          this.isBusy = false;
          if (response.code === 200) {
            this.StateTmp = response.data;

            // this.loadCity();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    loadCountry() {
      let form = {
        url: "master/country/all",
        params: {
          order_key: "asc",
          order_by: "name",
          active: 1,
        },
      };
      this.isBusy = true;
      this.getData(form)
        .then((response) => {
          this.isBusy = false;
          if (response.code === 200) {
            this.CountryTmp = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
<style>
.datepicker-container {
  width: 100%;
}

input.mx-input {
  border: none;
}

.form-control:hover {
  box-shadow: #b49b57;
  border-color: #b49b57;
}
.filepond--drop-label {
  height: 148px !important;
}
.filepond--drop-label.filepond--drop-label label {
  margin-top: 100px;
  text-align: center !important;
  color: black !important;
  font-size: small;
}
</style>
<style scoped>
/* Define la altura máxima y permite el desplazamiento */
.scrollable {
  max-height: 400px;
  overflow-y: auto;
}
.user-header {
  font-weight: bold;
  font-size: 15.6px;
}
.user-row {
  font-size: 15.6px;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.my-input-style {
  color: rgb(0, 0, 0);
  background-color: #ffffff;
  border: none;
  border-bottom: 1px solid rgb(0, 0, 0);
  width: 100%;
}
</style>